"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tora-e-piccilli": {
    "e834d143": [{
      "hkey": "caf7848f",
      "slug": "tora-e-piccilli",
      "name": "Tora e Piccilli",
      "primary": true,
      "skipSearch": false
    }],
    "stafforisi": [{
      "hkey": "caf7848f",
      "slug": "tora-e-piccilli",
      "name": "Tora e Piccilli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;